import request from '@/utils/request'

/**
 * 查询用户组
 * @param {Object} params 
 * @returns 
 */
export function listUserGroup(params) {
  return request({
    url: '/admin/system/user_group/list',
    method: 'GET',
    params,
  })
}

/**
 * 查询用户组
 * @param {Object} params 
 * @returns 
 */
export function queryUserGroupById(id) {
  return request({
    url: '/admin/system/user_group/queryById?_id=' + id,
    method: 'GET',
  })
}



/**
 * 添加用户组
 * @param {Object} data 
 * @returns 
 */
export function addUserGroup(data) {
  return request({
    url: '/admin/system/user_group/add',
    method: 'POST',
    data,
  })
}


/**
 * 修改用户组
 * @param {Object} data 
 * @returns 
 */
export function updateUserGroup(data) {
  return request({
    url: '/admin/system/user_group/update',
    method: 'POST',
    data,
  })
}


/**
 * 删除
 * @param {Object} data 
 * @returns 
 */
export function delUserGroup(data) {
  return request({
    url: '/admin/system/user_group/del',
    method: 'DELETE',
    data,
  })
}


/**
 * 添加用户组
 * @param {Object} data 
 * @returns 
 */
export function getCourseById(data) {
  return request({
    url: '/admin/system/user_group/getById',
    method: 'get',
    data,
  })
}

